import React, { FC, useState } from 'react';
import { Box, Text, Icon, AvatarSize } from '@bechtel/gds';
import { AvatarRegularStyled, StencilItemStyled } from './styled';
import { useName } from '@bechtel/client-common';
import { RodRequestStencilProps } from './types';
import { filter, map } from 'lodash';
import { CrewMember, RodRequestCaddy, RodRequestCaddyStatusCode } from '@bechtel/types';
import { Trans } from '@lingui/macro';
import { SectionToggle } from '../section-toggle';
import { TextWithEllipsis } from '@bechtel/client-common';

const SelectedStencilItem = (stencil: CrewMember, caddies: RodRequestCaddy[]) => {
  const { getFullName } = useName();
  const issuedCaddiesLength = filter(
    caddies,
    (caddy) => caddy.currentStatusI18n === RodRequestCaddyStatusCode.ISSUED
  )?.length;
  return (
    <Box justifyContent={{ sm: 'space-between' }}>
      <StencilItemStyled>
        <AvatarRegularStyled
          hasImageUrl={stencil && stencil.imageUrl ? true : false}
          size={AvatarSize.MEDIUM}
          src={stencil && stencil.imageUrl ? stencil.imageUrl : undefined}
        />
        <Box flexDirection={{ sm: 'column' }} mr={{ sm: '200' }} css={{ lineHeight: '1.1' }}>
          <Text size="400" color="grey.600" family="graphikCompact" weight="500">
            {getFullName(stencil.firstName, stencil.lastName)}
          </Text>
          {stencil.badgeNumber && (
            <Text size="300" color="grey.600" family="graphikCompact" transform="capitalize" style={{ opacity: '0.7' }}>
              {stencil.badgeNumber}
            </Text>
          )}
        </Box>
      </StencilItemStyled>
      {issuedCaddiesLength > 0 && (
        <Box alignItems={{ sm: 'center' }}>
          {filter(caddies, (caddy) => caddy.currentStatusI18n === RodRequestCaddyStatusCode.RETURNED)?.length ===
            issuedCaddiesLength && <Icon icon="check-circle" iconStyle="solid" fillColor="green.500" />}
          &nbsp;
          <TextWithEllipsis>
            <Text weight={600} size="300">
              {issuedCaddiesLength}
            </Text>
            &nbsp;
            <Text weight={400} size="300">
              <Trans>Caddies</Trans>
            </Text>
          </TextWithEllipsis>
        </Box>
      )}
    </Box>
  );
};

const getAssignedCaddies = (stencil: CrewMember, caddies: RodRequestCaddy[]) => {
  const assignCaddies: RodRequestCaddy[] = [];
  map(caddies, (caddy: RodRequestCaddy) => {
    filter(caddy.stencils, (caddyStencil: CrewMember) => {
      if (caddyStencil.id === stencil.id) {
        assignCaddies.push(caddy);
      }
    });
  });
  return assignCaddies;
};

export const RodRequestStencils: FC<RodRequestStencilProps> = ({ stencils, caddies }) => {
  const [isStencilListOpen, setIsStencilListOpen] = useState(true);

  return (
    <>
      <SectionToggle
        toggle={() => setIsStencilListOpen(!isStencilListOpen)}
        heading={'Welders'}
        isOpen={isStencilListOpen}
      />
      {isStencilListOpen && stencils?.length && (
        <Box
          flexDirection={{ sm: 'column' }}
          pl={{ sm: '500' }}
          pr={{ sm: '300' }}
          py={{ sm: '400' }}
          css={{ background: 'white' }}
          data-testid="stencils-list-container"
        >
          {map(stencils, (item) => SelectedStencilItem(item, getAssignedCaddies(item, caddies)))}
        </Box>
      )}
    </>
  );
};
